import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import KivaProxy from "@/utils/kivaProxy/src";
import participantTransformer from "@/transformers/ParticipantTransformer";
export default {
  props: {
    value: [Object, Array],
    skey: [String, Number]
  },
  data: function data() {
    return {
      mutableValue: this.value,
      loading: false,
      participants: [],
      formattedUsers: [],
      stable: []
    };
  },
  created: function created() {
    this.setValue();
    this.formatUsers();
  },
  methods: {
    get_name: function get_name(ap) {
      if (ap) {
        var parsed = ap.split("_");
        var length = parsed.length - 1;
        return parsed[length];
      }
    },
    get_avatar: function get_avatar(ap) {
      if (ap) {
        var parsed = ap.split("_");
        var length = parsed.length - 1;
        var name = parsed[length].split(" ");
        var nm = "";
        name.forEach(function (k) {
          nm = nm + k.charAt(0);
        });
        return nm;
      }
    },
    setValue: function setValue() {
      var _this = this;
      if (this.value && this.value[0] && this.value[0].target_record_id) {
        this.participants = _toConsumableArray(this.value);
        this.value.forEach(function (item, key) {
          _this.value[key] = item.target_app_id + '_' + item.target_model_id + '_' + item.target_record_id + '_' + item.target_email + '_' + item.target_name;
        });
      }
      this.mutableValue = this.value;
    },
    formatUsers: function formatUsers() {
      var _this2 = this;
      var user = this.$store.state.users.USERS;
      user.forEach(function (k) {
        _this2.formattedUsers.push({
          target_record_id: k.userId,
          target_name: k.fullName,
          target_app_id: 'system',
          target_model_id: 'user',
          target_email: k.email
        });
      });
    },
    getParticipants: function getParticipants(query) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var fields;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(query !== "")) {
                _context.next = 7;
                break;
              }
              _this3.loading = true;
              fields = _this3.formattedUsers.filter(function (k) {
                return k.target_email.includes(query) || k.target_name.includes(query);
              });
              _context.next = 5;
              return new KivaProxy({
                endpoint: "crm/contact"
              }).setKeyword(query).all().then(function (response) {
                _this3.loading = false;
                console.log("records", response.records);
                response.records.forEach(function (k) {
                  fields.push({
                    target_record_id: k.record_id,
                    target_name: "".concat(k.firstname, " ").concat(k.lastname),
                    target_app_id: 'crm',
                    target_model_id: 'contact',
                    target_email: k.email
                  });
                });
              }).catch(function (err) {
                _this3.loading = false;
              });
            case 5:
              _this3.participants = fields;
              return _context.abrupt("return", fields);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  watch: {
    mutableValue: function mutableValue(val) {
      this.$emit("input", val);
    },
    skey: function skey(val) {
      this.setValue();
    },
    value: function value(val) {
      this.setValue();
    }
  }
};